import { withI18n } from 'react-i18next';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import CategoriesMobileMenu from './CategoriesMobileMenu';

/* Redux content */
import {
  categoriesSel,
  categoriesPendingSel,
  failedSel,
  errorSel,
  categoriesActions
} from 'src/store/modules/categories';

interface IDispatchFromProps {
  getCategories(): void;
}

const mapStateToProps = (state: any) => {
  return {
    categories: categoriesSel(state),
    getCategoriesIsPending: categoriesPendingSel(state),
    apiFailed: failedSel(state),
    error: errorSel(state)
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  getCategories: () => dispatch(categoriesActions.getCategories())
});

export const pureComponent = CategoriesMobileMenu;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(withRouter(CategoriesMobileMenu)));
